export default {
  "hero_title_line1": "Kakobuy Spreadsheet",
  "hero_title_line2": "Polska 2026",
  "hero_subtitle": "Odkryj najlepszy arkusz zakupowy Kakobuy dla Polski. Ponad 500+ sprawdzonych linków do produktów w jednym miejscu. Oszczędzaj czas i pieniądze z naszym spreadsheetem.",
  "hero_cta": "Zobacz Spreadsheet",
  "hero_social_proof": "Zaufany przez 10,000+ kupujących",
  "categories_title": "Kategorie Produktów",
  "categories_subtitle": "Wybierz interesującą Cię kategorię",
  "cta_title_line1": "Rozpocznij zakupy",
  "cta_title_line2": "z Kakobuy",
  "cta_description": "Skorzystaj z naszego sprawdzonego arkusza Kakobuy Spreadsheet i odkryj tysiące produktów w najlepszych cenach. Szybka dostawa do Polski, bezpieczne płatności i sprawdzone linki.",
  "cta_button": "Buy It Now",
  "about_label": "Dlaczego Kakobuy Spreadsheet?",
  "about_title_line1": "Twój kompletny",
  "about_title_line2": "przewodnik po",
  "about_title_line3": "zakupach online",
  "about_btn_primary": "Zobacz Arkusz",
  "about_btn_secondary": "Dowiedz się więcej",
  "about_feature_1": "Szybka Dostawa",
  "about_feature_2": "Bezpieczeństwo",
  "about_feature_3": "Sprawdzone Linki",
  "about_feature_4": "Wsparcie 24/7",
  "about_feature_5": "Gwarancja Jakości",
  "articles_title": "Poradniki SEO",
  "articles_subtitle": "Artykuły o Kakobuy Spreadsheet",
  "testimonial_quote": "Dzięki Kakobuy Spreadsheet zaoszczędziłem setki złotych na zakupach. Wszystkie linki są sprawdzone i aktualizowane co tydzień. Polecam każdemu, kto robi zakupy online!",
  "testimonial_name": "Michał Nowak",
  "testimonial_platform": "Trustpilot",
  "testimonial_label": "Opinie klientów",
}